// extracted by mini-css-extract-plugin
export var tosLink = "_90-0";